export default "__VITE_ASSET__rwQ216dx__"